import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheVisionaryEdge from "./sections/TheVisionaryEdge";
import StrategicCapabilities from "./sections/StrategicCapabilities";
import FromConceptToScreen from "./sections/FromConceptToScreen";
import ImpactByTheNumbers from "./sections/ImpactByTheNumbers";
import SecureTheDeck from "./sections/SecureTheDeck";
import StudioFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <TheVisionaryEdge />
      <StrategicCapabilities />
      <FromConceptToScreen />
      <ImpactByTheNumbers />
      <SecureTheDeck />
      <StudioFooter />
    </div>;
}